var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 267.88 255.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #28aee4;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        stroke: #134d65;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m235.36,106.19c6.52,5.55,10.65,13.82,10.65,23.05,0,16.72-13.55,30.27-30.27,30.27s-30.27-13.55-30.27-30.27,13.55-30.27,30.27-30.27c5.23,0,10.15,1.33,14.44,3.66"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m206.59,138.99c3.53,6.7,19.69,5.94,18.1-3.38-.41-2.41-2.09-4-4.16-5.02-3.88-1.92-6.7-.82-10.55-3.26-1.6-1.01-2.83-2.45-3.18-4.47-1.6-9.32,14.56-10.08,18.1-3.37"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 215.74,
    y1: 149,
    x2: 215.74,
    y2: 143.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 215.74,
    y1: 115.06,
    x2: 215.74,
    y2: 109.47
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 51.47,
    cy: 128.33,
    r: 29.59,
    transform: "translate(-85.28 148.76) rotate(-76.64)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m52.37,107.76c0,.5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9.9.4.9.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m30.9,127.43c.5,0,.9.4.9.9s-.4.9-.9.9-.9-.4-.9-.9.4-.9.9-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m50.57,148.9c0-.5.4-.9.9-.9s.9.4.9.9-.4.9-.9.9-.9-.4-.9-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m72.04,129.23c-.5,0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9-.4.9-.9.9Z"
  }))), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "51.47 116.06 51.47 128.33 60.32 128.33"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m215.87,185.75c-4.31,3.49-9.81,5.56-15.79,5.56v-8.34l-21.92,17.44,21.92,17.44v-8.34c9.43,0,18.14-3,25.26-8.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m75.69,214.53c-3.49-4.31-5.56-9.81-5.56-15.79h8.34l-17.44-21.92-17.44,21.92h8.34c0,9.43,3,18.14,8.12,25.26"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m187.09,45.57c3.49,4.31,5.56,9.81,5.56,15.79h-8.34l17.44,21.92,17.44-21.92h-8.34c0-9.43-3-18.14-8.12-25.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m46.91,74.35c4.31-3.49,9.81-5.56,15.79-5.56v8.34l21.92-17.44-21.92-17.44v8.34c-9.43,0-18.14,3-25.26,8.12"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "117.54 190.18 117.54 181.59 158.38 181.59 158.38 237.56 149.78 237.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "117.54 190.18 149.78 190.18 149.78 237.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "117.54 190.18 108.94 190.18 108.94 246.16 149.78 246.16 149.78 237.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 119.95,
    y1: 209.57,
    x2: 138.77,
    y2: 209.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 138.77,
    y1: 223.54,
    x2: 119.95,
    y2: 223.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m133.66,28.04c5.06,0,9.16-4.1,9.16-9.16s-4.1-9.16-9.16-9.16-9.16,4.1-9.16,9.16,4.1,9.16,9.16,9.16"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 133.66,
    y1: 48.07,
    x2: 133.66,
    y2: 28.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 133.66,
    y1: 48.07,
    x2: 118.21,
    y2: 48.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 133.66,
    y1: 48.07,
    x2: 149.11,
    y2: 48.07
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "149.11 48.07 149.11 57.23 166.28 57.23 166.28 40.06 149.11 40.06 149.11 48.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "118.21 48.07 118.21 40.06 101.04 40.06 101.04 57.23 118.21 57.23 118.21 48.07"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m139.53,147.59c3.78-14.91,21.06-24.98,20.65-40.99-.33-12.86-11.23-24.88-25.85-24.88s-25.53,12.01-25.85,24.88c-.41,16,16.87,26.07,20.65,40.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m126.22,147.59v8.1c0,4.47,3.63,8.1,8.1,8.1s8.1-3.63,8.1-8.1v-8.1h-16.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m137.91,133.85l3.92-13.54c.82-2.83-1.3-5.65-4.24-5.65h-6.54c-2.94,0-5.06,2.82-4.24,5.65l3.92,13.54"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadline);
export default __webpack_public_path__ + "static/media/headline.2ac6c7933bfbe74580f0b7777aa413d0.svg";
export { ForwardRef as ReactComponent };